import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { setDefaultValidityWindow as setCoreSDKValidity } from "@/lib/clients";
import { setDefaultValidityWindow as setFarmSDKValidity } from "@/lib/farm-client";
import { useLifetimeStore } from "@/store/lifetime";

type LifetimeRound = number;
type LifetimeDurationSec = number;
const lifetimeValues: [LifetimeRound, LifetimeDurationSec][] = [
  [66, 3],
  [320, 15],
  [1000, 45],
];

export function LifetimeSettings() {
  const { lifetime, set: setStore } = useLifetimeStore();

  const onValueChange = (value: string) => {
    const lifetime = Number(value);
    setStore(lifetime);
    setCoreSDKValidity(lifetime);
    setFarmSDKValidity(lifetime);
  };
  const mins = lifetimeValues.find(([rnd]) => rnd === lifetime)![1];
  return (
    <>
      <h4 className="">Lifetime: {mins} minutes</h4>
      <ToggleGroup
        type="single"
        variant="outline"
        onValueChange={onValueChange}
        value={String(lifetime)}
        className="gap-3 mb-4"
      >
        {lifetimeValues.map(([rnd, mins]) => (
          <ToggleGroupItem
            key={`d${rnd}`}
            className="border rounded-md flex flex-col w-24 h-24"
            value={String(rnd)}
          >
            <span className="text-xl">{mins}</span> <span>minutes</span>
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
      <p className="text-sm">
        Myth transactions have a default lifetime of around 3 minutes, which includes
        the time taken to sign them. If you need more time to sign, you can
        increase this value.
      </p>
      <p className="text-sm text-muted-foreground">
        In the rare event that your transaction is not finalized soon after
        submitting, you need to wait for the duration of transaction lifetime in
        order to ensure that it does not get processed later than you expect.
      </p>
      <p className="text-sm text-muted-foreground">
        {" "}
        If you re-submit a new transaction without waiting, it
        can lead to inadvertent double spend. A short default is used for this
        reason.
      </p>
    </>
  );
}
